import React from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import { VisibilityOutlined, Info } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { useViewOnlyMode } from 'src/hooks/useViewOnlyMode';

const useStyles = makeStyles((theme) => ({
  banner: {
    backgroundColor: '#E3F2FD', // Light blue background
    borderBottom: `2px solid ${theme.palette.info.main}`,
    padding: theme.spacing(1, 2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  icon: {
    color: theme.palette.info.main,
    fontSize: '1.2rem',
  },
  text: {
    color: theme.palette.info.dark,
    fontWeight: 600,
    margin: 0,
  },
  infoButton: {
    fontSize: '0.75rem',
    padding: theme.spacing(0.5, 1),
    minWidth: 'auto',
  },
}));

const ViewOnlyBanner: React.FC = () => {
  const classes = useStyles();
  const { isViewOnlyMode, userEmail } = useViewOnlyMode();

  // Temporarily check session storage directly for testing
  const sessionViewOnlyMode = sessionStorage.getItem('view_only_mode');
  const manualCheck = sessionViewOnlyMode === 'true';

  // Show banner if either method detects view-only mode
  if (!isViewOnlyMode && !manualCheck) {
    return null;
  }

  const handleInfoClick = () => {
    // You could show a modal or tooltip with more information
    // For now, we'll just log to console to avoid using alert
    // In a real implementation, consider using a proper modal or snackbar component
  };

  const handleNewSystemClick = () => {
    const newEhrDomain = process.env.REACT_APP_NEW_EHR_DOMAIN || 'http://localhost:3001';
    const email = userEmail || '';
    const newEhrUrl = `${newEhrDomain}/login?email=${encodeURIComponent(email)}`;
    window.location.href = newEhrUrl;
  };

  return (
    <Box className={classes.banner}>
      <Box className={classes.content}>
        <VisibilityOutlined className={classes.icon} />
        <Typography variant="body2" className={classes.text}>
          View-Only Mode: You can view data but cannot make changes.{' '}
          <button
            type="button"
            onClick={handleNewSystemClick}
            style={{ 
              background: 'none',
              border: 'none',
              color: 'inherit', 
              textDecoration: 'underline', 
              cursor: 'pointer',
              fontSize: 'inherit',
              fontFamily: 'inherit',
              padding: 0,
              margin: 0
            }}
          >
            Login to the new experience →
          </button>
        </Typography>
      </Box>
      <Button
        size="small"
        variant="text"
        color="primary"
        startIcon={<Info />}
        onClick={handleInfoClick}
        className={classes.infoButton}
      >
        Info
      </Button>
    </Box>
  );
};

export default ViewOnlyBanner;